function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M8 7l4-4m0 0l4 4m-4-4v18",
  stroke: "#4D4D4D",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgArrowNarrowUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default __webpack_public_path__ + "/img/arrow-narrow-up.svg";
export { SvgArrowNarrowUp as ReactComponent };